/**
 * This file was generated by Style Dictionary and contains the semantic tokens for the ursa-dark theme.
 * To make changes, edit the corresponding JSON file in the token-groups/themes directory.
 * This file is automatically generated and should not be edited directly.
 **/
export const ursaDarkColors = {
  colorBackgroundSurfacesOverlay: "#6b7394",
  colorBackgroundSurfacesStage: "#363c54",
  colorBackgroundSurfacesCanvas: "#11131d",
  colorBackgroundSurfacesBody: "#11131d",
  colorBackgroundSurfacesWork: "#212536",
  colorBackgroundNeutralWeakest: "#363c54",
  colorBackgroundNeutralWeaker: "#4c5470",
  colorBackgroundNeutralWeak: "#5f6786",
  colorBackgroundNeutralDefault: "#6b7394",
  colorBackgroundNeutralStrong: "#878dab",
  colorBackgroundNeutralStronger: "#a6acc4",
  colorBackgroundNeutralStrongest: "#b8bdd1",
  colorBackgroundNeutralInverseWeakest: "#a6acc4",
  colorBackgroundNeutralInverseWeaker: "#878dab",
  colorBackgroundNeutralInverseWeak: "#5f6786",
  colorBackgroundNeutralInverseStrongest: "#11131d",
  colorBackgroundNeutralInverseStronger: "#212536",
  colorBackgroundNeutralInverseStrong: "#363c54",
  colorBackgroundNeutralInverseDefault: "#4c5470",
  colorBackgroundSlateStrongest: "#b8bdd1",
  colorBackgroundSlateStronger: "#a6acc4",
  colorBackgroundSlateStrong: "#878dab",
  colorBackgroundSlateDefault: "#6b7394",
  colorBackgroundSlateWeak: "#5f6786",
  colorBackgroundSlateWeaker: "#4c5470",
  colorBackgroundSlateWeakest: "#363c54",
  colorBackgroundSlateInverseStrongest: "#11131d",
  colorBackgroundSlateInverseStronger: "#212536",
  colorBackgroundSlateInverseStrong: "#363c54",
  colorBackgroundSlateInverseDefault: "#4c5470",
  colorBackgroundSlateInverseWeak: "#5f6786",
  colorBackgroundSlateInverseWeaker: "#878dab",
  colorBackgroundSlateInverseWeakest: "#a6acc4",
  colorBackgroundPrimaryStrongest: "#80a6ff",
  colorBackgroundPrimaryStronger: "#6692fa",
  colorBackgroundPrimaryStrong: "#3a6fe9",
  colorBackgroundPrimaryDefault: "#2d60d7",
  colorBackgroundPrimaryWeak: "#184bc3",
  colorBackgroundPrimaryWeaker: "#0d3491",
  colorBackgroundPrimaryWeakest: "#031c59",
  colorBackgroundDestructiveStrongest: "#f29298",
  colorBackgroundDestructiveStronger: "#e96d75",
  colorBackgroundDestructiveStrong: "#df2a36",
  colorBackgroundDestructiveDefault: "#ce1723",
  colorBackgroundDestructiveWeak: "#ab0d17",
  colorBackgroundDestructiveWeaker: "#7f050d",
  colorBackgroundDestructiveWeakest: "#570006",
  colorBackgroundNotificationsDefault: "#d64529",
  colorBackgroundNotificationsWeak: "#878dab",
  colorBackgroundInfoDefault: "#ebfaff",
  colorBackgroundInfoWeak: "#b6e8f7",
  colorBackgroundInfoWeaker: "#157e9d",
  colorBackgroundSuccessDefault: "#e7fdeb",
  colorBackgroundSuccessWeak: "#a1edad",
  colorBackgroundSuccessWeaker: "#29ae40",
  colorBackgroundWarningDefault: "#fff6e0",
  colorBackgroundWarningWeak: "#fbda8d",
  colorBackgroundWarningWeaker: "#dea41b",
  colorBackgroundErrorDefault: "#fff5f6",
  colorBackgroundErrorWeak: "#fed7da",
  colorBackgroundErrorWeaker: "#e96d75",
  colorBackgroundSpectrumAzureStrongest: "#ebfaff",
  colorBackgroundSpectrumAzureStronger: "#c6effa",
  colorBackgroundSpectrumAzureStrong: "#b6e8f7",
  colorBackgroundSpectrumAzureDefault: "#98dcf1",
  colorBackgroundSpectrumAzureWeak: "#6acae7",
  colorBackgroundSpectrumAzureWeaker: "#3ab9df",
  colorBackgroundSpectrumAzureWeakest: "#1ea0c8",
  colorBackgroundSpectrumMintStrongest: "#e7fdeb",
  colorBackgroundSpectrumMintStronger: "#d2f9d8",
  colorBackgroundSpectrumMintStrong: "#a1edad",
  colorBackgroundSpectrumMintDefault: "#8ee69d",
  colorBackgroundSpectrumMintWeak: "#62d574",
  colorBackgroundSpectrumMintWeaker: "#32c84c",
  colorBackgroundSpectrumMintWeakest: "#29ae40",
  colorBackgroundSpectrumRedStrongest: "#fff5f6",
  colorBackgroundSpectrumRedStronger: "#ffe0e3",
  colorBackgroundSpectrumRedStrong: "#fed7da",
  colorBackgroundSpectrumRedDefault: "#fbc6c9",
  colorBackgroundSpectrumRedWeak: "#f7abb0",
  colorBackgroundSpectrumRedWeaker: "#f29298",
  colorBackgroundSpectrumRedWeakest: "#e96d75",
  colorBackgroundSpectrumPinkStrongest: "#fff5fa",
  colorBackgroundSpectrumPinkStronger: "#fee1f2",
  colorBackgroundSpectrumPinkStrong: "#fdd3ec",
  colorBackgroundSpectrumPinkDefault: "#fdc4e4",
  colorBackgroundSpectrumPinkWeak: "#f9a4d6",
  colorBackgroundSpectrumPinkWeaker: "#f589c8",
  colorBackgroundSpectrumPinkWeakest: "#e76ab3",
  colorBackgroundSpectrumRoseStrongest: "#fff5fa",
  colorBackgroundSpectrumRoseStronger: "#fee1f2",
  colorBackgroundSpectrumRoseStrong: "#fdd3ec",
  colorBackgroundSpectrumRoseDefault: "#fdc4e4",
  colorBackgroundSpectrumRoseWeak: "#f9a4d6",
  colorBackgroundSpectrumRoseWeaker: "#e76ab3",
  colorBackgroundSpectrumRoseWeakest: "#e76ab3",
  colorBackgroundSpectrumOrchidStrongest: "#fdf5ff",
  colorBackgroundSpectrumOrchidStronger: "#f8ddfd",
  colorBackgroundSpectrumOrchidStrong: "#f5d0fb",
  colorBackgroundSpectrumOrchidDefault: "#f0c3f8",
  colorBackgroundSpectrumOrchidWeak: "#e5a7f1",
  colorBackgroundSpectrumOrchidWeaker: "#db91e8",
  colorBackgroundSpectrumOrchidWeakest: "#ce73de",
  colorBackgroundSpectrumVioletStrongest: "#f8f5ff",
  colorBackgroundSpectrumVioletStronger: "#ebe0ff",
  colorBackgroundSpectrumVioletStrong: "#e0d1ff",
  colorBackgroundSpectrumVioletDefault: "#d6c2ff",
  colorBackgroundSpectrumVioletWeak: "#c9adff",
  colorBackgroundSpectrumVioletWeaker: "#bb99ff",
  colorBackgroundSpectrumVioletWeakest: "#a87efb",
  colorBackgroundSpectrumIndigoStrongest: "#f8f5ff",
  colorBackgroundSpectrumIndigoStronger: "#ebe0ff",
  colorBackgroundSpectrumIndigoStrong: "#e0d1ff",
  colorBackgroundSpectrumIndigoDefault: "#d6c2ff",
  colorBackgroundSpectrumIndigoWeak: "#c9adff",
  colorBackgroundSpectrumIndigoWeaker: "#bb99ff",
  colorBackgroundSpectrumIndigoWeakest: "#a87efb",
  colorBackgroundSpectrumBlueStrongest: "#f5f8ff",
  colorBackgroundSpectrumBlueStronger: "#dbe6ff",
  colorBackgroundSpectrumBlueStrong: "#c7d8ff",
  colorBackgroundSpectrumBlueDefault: "#b8cdff",
  colorBackgroundSpectrumBlueWeak: "#9ebbff",
  colorBackgroundSpectrumBlueWeaker: "#80a6ff",
  colorBackgroundSpectrumBlueWeakest: "#6692fa",
  colorBackgroundSpectrumAquaStrongest: "#e8fdf9",
  colorBackgroundSpectrumAquaStronger: "#b5f2e6",
  colorBackgroundSpectrumAquaStrong: "#9cecdc",
  colorBackgroundSpectrumAquaDefault: "#86e4d1",
  colorBackgroundSpectrumAquaWeak: "#5ad3bb",
  colorBackgroundSpectrumAquaWeaker: "#30c0a3",
  colorBackgroundSpectrumAquaWeakest: "#28a98f",
  colorBackgroundSpectrumTealStrongest: "#e8fdf9",
  colorBackgroundSpectrumTealStronger: "#b5f2e6",
  colorBackgroundSpectrumTealStrong: "#9cecdc",
  colorBackgroundSpectrumTealDefault: "#86e4d1",
  colorBackgroundSpectrumTealWeak: "#5ad3bb",
  colorBackgroundSpectrumTealWeaker: "#30c0a3",
  colorBackgroundSpectrumTealWeakest: "#28a98f",
  colorBackgroundSpectrumGreenStrongest: "#e7fdeb",
  colorBackgroundSpectrumGreenStronger: "#b9f4c3",
  colorBackgroundSpectrumGreenStrong: "#a1edad",
  colorBackgroundSpectrumGreenDefault: "#8ee69d",
  colorBackgroundSpectrumGreenWeak: "#62d574",
  colorBackgroundSpectrumGreenWeaker: "#32c84c",
  colorBackgroundSpectrumGreenWeakest: "#29ae40",
  colorBackgroundSpectrumYellowStrongest: "#fff6e0",
  colorBackgroundSpectrumYellowStronger: "#fff0cc",
  colorBackgroundSpectrumYellowStrong: "#fde6af",
  colorBackgroundSpectrumYellowDefault: "#fbda8d",
  colorBackgroundSpectrumYellowWeak: "#f9cd67",
  colorBackgroundSpectrumYellowWeaker: "#efb32a",
  colorBackgroundSpectrumYellowWeakest: "#dea41b",
  colorBackgroundSpectrumOrangeStrongest: "#ffeeeb",
  colorBackgroundSpectrumOrangeStronger: "#ffe1dc",
  colorBackgroundSpectrumOrangeStrong: "#fed5cd",
  colorBackgroundSpectrumOrangeDefault: "#fec8be",
  colorBackgroundSpectrumOrangeWeak: "#fda796",
  colorBackgroundSpectrumOrangeWeaker: "#fb8f79",
  colorBackgroundSpectrumOrangeWeakest: "#f06b51",
  colorBackgroundSpectrumGoldStrongest: "#fff6e0",
  colorBackgroundSpectrumGoldStronger: "#fff0cc",
  colorBackgroundSpectrumGoldStrong: "#fde6af",
  colorBackgroundSpectrumGoldDefault: "#fbda8d",
  colorBackgroundSpectrumGoldWeak: "#f9cd67",
  colorBackgroundSpectrumGoldWeaker: "#efb32a",
  colorBackgroundSpectrumGoldWeakest: "#dea41b",
  colorBackgroundSpectrumNeutralStrongest: "#f5f6fa",
  colorBackgroundSpectrumNeutralStronger: "#e5e7f0",
  colorBackgroundSpectrumNeutralStrong: "#dcdeea",
  colorBackgroundSpectrumNeutralDefault: "#d0d3e2",
  colorBackgroundSpectrumNeutralWeak: "#b8bdd1",
  colorBackgroundSpectrumNeutralWeaker: "#a6acc4",
  colorBackgroundSpectrumNeutralWeakest: "#878dab",
  colorBackgroundSpectrumSlateStrongest: "#f5f6fa",
  colorBackgroundSpectrumSlateStronger: "#e5e7f0",
  colorBackgroundSpectrumSlateStrong: "#dcdeea",
  colorBackgroundSpectrumSlateDefault: "#d0d3e2",
  colorBackgroundSpectrumSlateWeak: "#b8bdd1",
  colorBackgroundSpectrumSlateWeaker: "#a6acc4",
  colorBackgroundSpectrumSlateWeakest: "#878dab",
  colorBackgroundAiIconWrapperDefault: "#8959e8",
  colorTextNeutralStronger: "#ffffff",
  colorTextNeutralStrong: "#ffffff",
  colorTextNeutralDefault: "#e5e7f0",
  colorTextNeutralWeak: "#b8bdd1",
  colorTextNeutralWeaker: "#a6acc4",
  colorTextNeutralWeakest: "#878dab",
  colorTextSlateStrong: "#ffffff",
  colorTextSlateDefault: "#e5e7f0",
  colorTextSlateWeak: "#b8bdd1",
  colorTextSlateWeaker: "#a6acc4",
  colorTextSlateWeakest: "#878dab",
  colorTextNeutralInverseStrong: "#ffffff",
  colorTextNeutralInverseDefault: "#d0d3e2",
  colorTextNeutralInverseWeak: "#a6acc4",
  colorTextSlateInverseStrong: "#ffffff",
  colorTextSlateInverseDefault: "#f5f6fa",
  colorTextSlateInverseWeak: "#e5e7f0",
  colorTextPrimaryStrongest: "#3a6fe9",
  colorTextPrimaryStronger: "#6692fa",
  colorTextPrimaryStrong: "#9ebbff",
  colorTextPrimaryDefault: "#c7d8ff",
  colorTextPrimaryWeak: "#dbe6ff",
  colorTextPrimaryWeaker: "#ebf1ff",
  colorTextPrimaryWeakest: "#f5f8ff",
  colorTextInfoDefault: "#3ab9df",
  colorTextInfoWeak: "#157e9d",
  colorTextSuccessDefault: "#32c84c",
  colorTextSuccessWeak: "#29ae40",
  colorTextWarningDefault: "#dea41b",
  colorTextWarningWeak: "#dea41b",
  colorTextErrorDefault: "#f29298",
  colorTextErrorWeak: "#e96d75",
  colorTextDestructiveStrongest: "#330003",
  colorTextDestructiveStronger: "#7f050d",
  colorTextDestructiveStrong: "#ab0d17",
  colorTextDestructiveDefault: "#f7abb0",
  colorTextDestructiveWeak: "#fbc6c9",
  colorTextDestructiveWeaker: "#fed7da",
  colorTextDestructiveWeakest: "#fff5f6",
  colorTextSpectrumSlateDefault: "#212536",
  colorTextSpectrumSlateStrong: "#4c5470",
  colorTextSpectrumAzureDefault: "#022a36",
  colorTextSpectrumAzureStrong: "#0b5c75",
  colorTextSpectrumMintDefault: "#042f0a",
  colorTextSpectrumMintStrong: "#0f621c",
  colorTextSpectrumRedDefault: "#570006",
  colorTextSpectrumRedStrong: "#ab0d17",
  colorTextSpectrumPinkDefault: "#4c062f",
  colorTextSpectrumPinkStrong: "#992468",
  colorTextSpectrumRoseDefault: "#4c062f",
  colorTextSpectrumRoseStrong: "#992468",
  colorTextSpectrumOrchidDefault: "#41064b",
  colorTextSpectrumOrchidStrong: "#8b259d",
  colorTextSpectrumIndigoWeak: "#160042",
  colorTextSpectrumIndigoDefault: "#26026e",
  colorTextSpectrumIndigoStrong: "#6329d6",
  colorTextSpectrumVioletDefault: "#26026e",
  colorTextSpectrumVioletStrong: "#6329d6",
  colorTextSpectrumBlueDefault: "#031c59",
  colorTextSpectrumBlueStrong: "#184bc3",
  colorTextSpectrumAquaDefault: "#042a23",
  colorTextSpectrumAquaStrong: "#0f6151",
  colorTextSpectrumTealDefault: "#042a23",
  colorTextSpectrumTealStrong: "#0f6151",
  colorTextSpectrumGreenDefault: "#042f0a",
  colorTextSpectrumGreenStrong: "#0f621c",
  colorTextSpectrumOrangeDefault: "#4c1106",
  colorTextSpectrumOrangeStrong: "#973421",
  colorTextSpectrumNeutralDefault: "#212536",
  colorTextSpectrumNeutralStrong: "#363c54",
  colorTextSpectrumGoldDefault: "#322301",
  colorTextSpectrumGoldStrong: "#705006",
  colorTextSpectrumYellowDefault: "#322301",
  colorTextSpectrumYellowStrong: "#705006",
  colorBorderSurfacesBody: "#11131d",
  colorBorderSurfacesWork: "#11131d",
  colorBorderSurfacesCanvas: "#11131d",
  colorBorderSurfacesStage: "#363c54",
  colorBorderSurfacesFocus: "#3a6fe9",
  colorBorderNeutralStrongest: "#d0d3e2",
  colorBorderNeutralStronger: "#b8bdd1",
  colorBorderNeutralStrong: "#a6acc4",
  colorBorderNeutralDefault: "#878dab",
  colorBorderNeutralWeak: "#6b7394",
  colorBorderNeutralWeaker: "#5f6786",
  colorBorderNeutralWeakest: "#363c54",
  colorBorderSlateStrongest: "#d0d3e2",
  colorBorderSlateStronger: "#b8bdd1",
  colorBorderSlateStrong: "#a6acc4",
  colorBorderSlateDefault: "#878dab",
  colorBorderSlateWeak: "#6b7394",
  colorBorderSlateWeaker: "#5f6786",
  colorBorderSlateWeakest: "#363c54",
  colorBorderPrimaryDefault: "#6692fa",
  colorBorderPrimaryWeak: "#3a6fe9",
  colorBorderPrimaryWeaker: "#2d60d7",
  colorBorderPrimaryWeakest: "#184bc3",
  colorBorderDestructiveDefault: "#e96d75",
  colorBorderDestructiveWeak: "#df2a36",
  colorBorderDestructiveWeaker: "#ce1723",
  colorBorderDestructiveWeakest: "#ab0d17",
  colorBorderSuccessDefault: "#29ae40",
  colorBorderWarningDefault: "#bf8e1d",
  colorBorderErrorDefault: "#e96d75",
  colorBorderSpectrumRedDefault: "#e96d75",
  colorBorderSpectrumOrangeDefault: "#f06b51",
  colorBorderSpectrumGoldDefault: "#bf8e1d",
  colorBorderSpectrumYellowDefault: "#bf8e1d",
  colorBorderSpectrumGreenDefault: "#29ae40",
  colorBorderSpectrumMintDefault: "#29ae40",
  colorBorderSpectrumTealDefault: "#28a98f",
  colorBorderSpectrumAquaDefault: "#28a98f",
  colorBorderSpectrumAzureDefault: "#1ea0c8",
  colorBorderSpectrumBlueDefault: "#6692fa",
  colorBorderSpectrumIndigoDefault: "#a87efb",
  colorBorderSpectrumVioletDefault: "#a87efb",
  colorBorderSpectrumOrchidDefault: "#ce73de",
  colorBorderSpectrumRoseDefault: "#e76ab3",
  colorBorderSpectrumPinkDefault: "#e76ab3",
  colorBorderSpectrumNeutralDefault: "#878dab",
  colorBorderSpectrumSlateDefault: "#878dab",
  colorIconsNeutralStrongest: "#d0d3e2",
  colorIconsNeutralStronger: "#b8bdd1",
  colorIconsNeutralStrong: "#a6acc4",
  colorIconsNeutralDefault: "#878dab",
  colorIconsNeutralWeak: "#6b7394",
  colorIconsNeutralWeaker: "#5f6786",
  colorIconsNeutralWeakest: "#4c5470",
  colorIconsSlateStrongest: "#d0d3e2",
  colorIconsSlateStronger: "#b8bdd1",
  colorIconsSlateStrong: "#a6acc4",
  colorIconsSlateDefault: "#878dab",
  colorIconsSlateWeak: "#6b7394",
  colorIconsSlateWeaker: "#5f6786",
  colorIconsSlateWeakest: "#4c5470",
  colorIconsNeutralInverseDefault: "#ffffff",
  colorIconsNeutralInverseWeak: "#dcdeea",
  colorIconsSlateInverseDefault: "#ffffff",
  colorIconsSlateInverseWeak: "#dcdeea",
  colorIconsPrimaryStrongest: "#031c59",
  colorIconsPrimaryStronger: "#184bc3",
  colorIconsPrimaryStrong: "#2d60d7",
  colorIconsPrimaryDefault: "#3a6fe9",
  colorIconsPrimaryWeak: "#6692fa",
  colorIconsPrimaryWeaker: "#80a6ff",
  colorIconsPrimaryWeakest: "#b8cdff",
  colorIconsPrimaryInverseStronger: "#f5f8ff",
  colorIconsDestructiveStrongest: "#fbc6c9",
  colorIconsDestructiveStronger: "#f7abb0",
  colorIconsDestructiveStrong: "#f29298",
  colorIconsDestructiveDefault: "#e96d75",
  colorIconsDestructiveWeak: "#df2a36",
  colorIconsDestructiveWeaker: "#ce1723",
  colorIconsDestructiveWeakest: "#ab0d17",
  colorIconsDestructiveInverseWeakest: "#fff5f6",
  colorIconsInfoDefault: "#0b5c75",
  colorIconsInfoWeak: "#80a6ff",
  colorIconsSuccessDefault: "#1d862f",
  colorIconsSuccessWeak: "#32c84c",
  colorIconsWarningDefault: "#88620c",
  colorIconsWarningWeak: "#dea41b",
  colorIconsErrorDefault: "#ce1723",
  colorIconsErrorWeak: "#e96d75",
  colorIconsSpectrumRedDefault: "#570006",
  colorIconsSpectrumOrangeDefault: "#4c1106",
  colorIconsSpectrumGoldDefault: "#322301",
  colorIconsSpectrumYellowDefault: "#322301",
  colorIconsSpectrumGreenDefault: "#042f0a",
  colorIconsSpectrumMintDefault: "#042f0a",
  colorIconsSpectrumTealDefault: "#042a23",
  colorIconsSpectrumAquaDefault: "#042a23",
  colorIconsSpectrumAzureDefault: "#022a36",
  colorIconsSpectrumBlueDefault: "#031c59",
  colorIconsSpectrumIndigoDefault: "#26026e",
  colorIconsSpectrumIndigoWeak: "#7847dc",
  colorIconsSpectrumIndigoWeaker: "#a87efb",
  colorIconsSpectrumIndigoWeakest: "#c9adff",
  colorIconsSpectrumVioletDefault: "#26026e",
  colorIconsSpectrumOrchidDefault: "#41064b",
  colorIconsSpectrumRoseDefault: "#4c062f",
  colorIconsSpectrumPinkDefault: "#4c062f",
  colorIconsSpectrumNeutralDefault: "#ffffff",
  colorIconsSpectrumSlateDefault: "#ffffff",
  colorElevationHighTop: "#11131d",
  colorElevationHighBottom: "#11131d",
  colorElevationDefaultTop: "#11131d",
  colorElevationDefaultBottom: "#11131d",
  colorElevationLowTop: "#11131d",
  colorElevationLowBottom: "#11131d",
  colorChartsHighContrast1Rest: "#9ebbff",
  colorChartsHighContrast1Hover: "#b8cdff",
  colorChartsHighContrast2Rest: "#3a6fe9",
  colorChartsHighContrast2Hover: "#6692fa",
  colorChartsHighContrast3Rest: "#1c826d",
  colorChartsHighContrast3Hover: "#28a98f",
  colorChartsHighContrast4Rest: "#8959e8",
  colorChartsHighContrast4Hover: "#a87efb",
  colorChartsHighContrast5Rest: "#6b7394",
  colorChartsHighContrast5Hover: "#878dab",
  colorChartsHighContrast6Rest: "#fda796",
  colorChartsHighContrast6Hover: "#fec8be",
  colorChartsHighContrast7Rest: "#3ab9df",
  colorChartsHighContrast7Hover: "#6acae7",
  colorChartsHighContrast8Rest: "#dea41b",
  colorChartsHighContrast8Hover: "#efb32a",
  colorChartsHighContrast9Rest: "#1d862f",
  colorChartsHighContrast9Hover: "#29ae40",
  colorChartsHighContrast10Rest: "#62d574",
  colorChartsHighContrast10Hover: "#a1edad",
  colorChartsHighContrast11Rest: "#ce73de",
  colorChartsHighContrast11Hover: "#db91e8",
  colorChartsHighContrast12Rest: "#d64529",
  colorChartsHighContrast12Hover: "#f06b51",
  colorChartsColorful1Rest: "#9ebbff",
  colorChartsColorful1Hover: "#c7d8ff",
  colorChartsColorful2Rest: "#b9f4c3",
  colorChartsColorful2Hover: "#b9f4c3",
  colorChartsColorful3Rest: "#efb32a",
  colorChartsColorful3Hover: "#fde6af",
  colorChartsColorful4Rest: "#f06b51",
  colorChartsColorful4Hover: "#fb8f79",
  colorChartsColorful5Rest: "#fda796",
  colorChartsColorful5Hover: "#fec8be",
  colorChartsColorful6Rest: "#e5a7f1",
  colorChartsColorful6Hover: "#f0c3f8",
  colorChartsColorful7Rest: "#ce73de",
  colorChartsColorful7Hover: "#db91e8",
  colorChartsColorful8Rest: "#98dcf1",
  colorChartsColorful8Hover: "#c6effa",
  colorChartsColorful9Rest: "#1ea0c8",
  colorChartsColorful9Hover: "#3ab9df",
  colorChartsColorful10Rest: "#3a6fe9",
  colorChartsColorful10Hover: "#6692fa",
  colorChartsSemanticNotStartedRest: "#a6acc4",
  colorChartsSemanticNotStartedHover: "#b8bdd1",
  colorChartsSemanticInProgressRest: "#80a6ff",
  colorChartsSemanticInProgressHover: "#9ebbff",
  colorChartsSemanticAtRiskRest: "#efb32a",
  colorChartsSemanticAtRiskHover: "#f9cd67",
  colorChartsSemanticCompletedRest: "#32c84c",
  colorChartsSemanticCompletedHover: "#62d574",
  colorChartsSemanticBlockedRest: "#f29298",
  colorChartsSemanticBlockedHover: "#f7abb0",
  symbolBackgroundColorYellowDefault: "#efb32a",
  symbolBackgroundColorYellowHover: "#dea41b",
  tooltipBackgroundColor: "#363c54",
  tooltipTextColor: "#f5f8ff",
  gradientNavigation: "linear-gradient(180deg, #184bc3, #5A43D7)",
  gradientUpsell: "linear-gradient(101deg, #F4F1FE 0%, #E3EBFD 33%, #ADC6FA 100%)",
  elevationLengthTopLow: "0px 6px 12px",
  elevationLengthTopDefault: "0px 6px 16px",
  elevationLengthTopHigh: "0px 12px 24px",
  elevationLengthBottomLow: "0px 2px 4px",
  elevationLengthBottomDefault: "0px 4px 6px",
  elevationLengthBottomHigh: "0px 6px 8px",
  elevationLow: "0px 6px 12px #11131d, 0px 2px 4px #11131d",
  elevationDefault: "0px 6px 16px #11131d, 0px 4px 6px #11131d",
  elevationHigh: "0px 12px 24px #11131d, 0px 6px 8px #11131d"
};
//# sourceMappingURL=ursa-dark.js.map